import { Component, OnInit, PLATFORM_ID, Inject, Renderer2, ElementRef, ViewChild, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';
import { isPlatformServer, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import Glide from '@glidejs/glide';
import { NavigationService } from 'src/app/_services/navigation.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-data-sensitive-plan',
  templateUrl: './data-sensitive-plan.component.html',
  styleUrls: ['./data-sensitive-plan.component.scss']
})
export class DataSensitivePlanComponent implements OnInit {
  text = 'プラン';
  displayText = '';
  showCursor = true;
  showLock = false;

  private timer: any;
  private isBrowser: boolean;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    this.titleService.setTitle("機密データ保護プラン | AI搭載英文校正ツールTrinka");
    this.metaTagService.updateTag({ name: 'description', content: "お客様のデータを元にしたAIの学習や、校正文章作成後のTrinka内部でのデータ保管を行わない機密データ保護プランです。お客様のデータを確実に守ります" });
    this.metaTagService.updateTag({ property: 'og:title', content: "機密データ保護プラン | AI搭載英文校正ツールTrinka" });
    this.metaTagService.updateTag({ property: 'og:description', content: "お客様のデータを元にしたAIの学習や、校正文章作成後のTrinka内部でのデータ保管を行わない機密データ保護プランです。お客様のデータを確実に守ります" });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/enterprise/confidential-data-plan-for-grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: "機密データ保護プラン | AI搭載英文校正ツールTrinka" });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "お客様のデータを元にしたAIの学習や、校正文章作成後のTrinka内部でのデータ保管を行わない機密データ保護プランです。お客様のデータを確実に守ります" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/enterprise/confidential-data-plan-for-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/jp/enterprise/confidential-data-plan-for-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/confidential-data-plan-for-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/confidential-data-plan-for-grammar-checker' });
    if (this.isBrowser) {
      this.runLoop();
    } else {
      // SSR: show final state immediately
      this.displayText = '';
      this.showCursor = false;
      this.showLock = true;
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }

  ngOnDestroy() {
    clearTimeout(this.timer);
  }

  runLoop() {
    this.displayText = '';
    this.showCursor = true;
    this.showLock = false;

    this.typeText();
  }

  typeText() {
    let index = 0;

    const typeInterval = setInterval(() => {
      this.displayText += this.text[index];
      index++;

      if (index === this.text.length) {
        clearInterval(typeInterval);
        this.timer = setTimeout(() => this.eraseText(), 800);
      }
    }, 120);
  }

  eraseText() {
    const eraseInterval = setInterval(() => {
      this.displayText = this.displayText.slice(0, -1);

      if (this.displayText.length === 0) {
        clearInterval(eraseInterval);
        this.showCursor = false;
        this.showLock = true;

        this.timer = setTimeout(() => this.runLoop(), 1500);
      }
    }, 80);
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  @ViewChild('targetElement') targetElement!: ElementRef;

  scrollToTarget() {
    if (this.targetElement) {
      this.targetElement.nativeElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  trackByFn(index: number, item: any): string | number {
    return item.id || index;
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }
  @ViewChild('bgVideo') bgVideo!: ElementRef<HTMLVideoElement>;
  @ViewChild('progressList') progressList!: ElementRef;
  autoplayTime = 5000;
  progressHeight = '0px';
  @ViewChild('glideRef') glideRef!: ElementRef;
  glide: any;
  activeIndex = 0;

  ngAfterViewInit() {
    this.glide = new Glide(this.glideRef.nativeElement, {
      type: 'slider',
      perView: 1,
      animationDuration: 400,
      autoplay: 6000,
      hoverpause: true
    });
  
    this.glide.mount();
  
    // initial state
    this.activeIndex = 0;
  
    this.glide.on('run.after', () => {
      this.activeIndex = -1;

      setTimeout(() => {
        this.activeIndex = this.glide.index;
      }, 50);
    });

    const video = this.bgVideo.nativeElement;
    video.muted = true;
    video.play().catch(() => {});
  }

  goToSlide(index: number) {
    this.activeIndex = -1;
  
    setTimeout(() => {
      this.glide.go('=' + index);
      this.activeIndex = index;
    }, 50);
  }

  industries = [
    {
      image: 'assets/images/enterprise/confidential-data/icons/healthcare.svg',
      bgimage: 'assets/images/enterprise/confidential-data/healthcare.webp',
      title: 'ヘルスケア＆医薬品',
      content: '事例紹介、医療レポート、医薬品開発文書など、プライバシーや規制の制限が問題となる文書  '
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/academic.svg',
      bgimage: 'assets/images/enterprise/confidential-data/academic.webp',
      title: '学術研究機関',
      content: '助成金提案書、未発表原稿、IRB申請書、提出前の学位論文の下書きなど'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/patent.svg',
      bgimage: 'assets/images/enterprise/confidential-data/patent.webp',
      title: '特許＆研究開発',
      content: '出願前の特許草案、発明開示、研究開発文書の作成、将来の知的財産を定義する技術仕様書など  '
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/legal.svg',
      bgimage: 'assets/images/enterprise/confidential-data/legal.webp',
      title: '法務＆コンプライアンス',
      content: '弁護士とクライアントのコミュニケーション、契約書、訴訟資料、機密を守らなければならない交渉記録など'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/finance.svg',
      bgimage: 'assets/images/enterprise/confidential-data/finance.webp',
      title: '金融サービス＆コンサルティング',
      content: '市場リスクを伴う投資分析、デューデリジェンスレポート、顧客文書、戦略的提案など'
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/cyber-security.svg',
      bgimage: 'assets/images/enterprise/confidential-data/cyber-security.webp',
      title: 'サイバーセキュリティ、防衛＆政府 ',
      content: '脅威情報、セキュリティ評価、通信制限、データプライバシーが必要な規制文書など '
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/creative.svg',
      bgimage: 'assets/images/enterprise/confidential-data/creative.webp',
      title: 'クリエイティブ、メディア＆競合他社情報 ',
      content: '未発表の企画文書、調査コンテンツ、市場調査、戦略的洞察など '
    },
    {
      image: 'assets/images/enterprise/confidential-data/icons/energy-infra.svg',
      bgimage: 'assets/images/enterprise/confidential-data/energy-infra.webp',
      title: 'エネルギー＆インフラ ',
      content: '長期計画や重要システムに関連する業務計画、探査データ、インフラ評価、戦略文書など'
    }
  ].map(item => ({
    ...item,
    words: item.content.split(' ')
  }));


  getWordDelay(wordIndex: number, totalWords: number) {
    const totalTime = this.autoplayTime / 1000; // convert to seconds
    const step = totalTime / totalWords;
    return (wordIndex * step) + 's';
  }

}
